var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50.5,
    r: 49.5,
    fill: "#BF1E2E",
    stroke: "#BF1E2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.3679 25.0909L53.7216 61.3587H46.8359L46.1896 25.0909H54.3679ZM50.2912 76.4723C48.9157 76.4723 47.7391 75.9917 46.7614 75.0305C45.7836 74.0528 45.303 72.8762 45.3196 71.5007C45.303 70.1418 45.7836 68.9818 46.7614 68.0206C47.7391 67.0428 48.9157 66.554 50.2912 66.554C51.6335 66.554 52.7936 67.0428 53.7713 68.0206C54.7491 68.9818 55.2462 70.1418 55.2628 71.5007C55.2462 72.4122 55.0059 73.2491 54.5419 74.0114C54.0945 74.7571 53.4979 75.3537 52.7521 75.8011C52.0064 76.2486 51.1861 76.4723 50.2912 76.4723Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfo);
export default __webpack_public_path__ + "static/media/alert_info.b71370cf12d7abaf8a21982464313c1a.svg";
export { ForwardRef as ReactComponent };